(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-about"] && !Shopify.designMode) return;
  try {
    
  // Sayaçlar: ekrana girince 0'dan hedef sayıya sayar. Sayı binlik ayraçla
  // (tr-TR: nokta) biçimlendirilir. Azaltılmış hareket tercihinde animasyon
  // atlanır, direkt hedef değer gösterilir.
  function melisAnimateCounter(el) {
    const target = parseInt(el.dataset.target, 10);
    const suffix = el.dataset.suffix || '';
    if (!Number.isFinite(target)) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target.toLocaleString('tr-TR') + suffix;
      return;
    }

    const duration = 1400;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(target * eased);
      el.textContent = value.toLocaleString('tr-TR') + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  document.querySelectorAll('[data-melis-counter]').forEach((el) => {
    if (!('IntersectionObserver' in window)) {
      melisAnimateCounter(el);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          melisAnimateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-header"]) return;
  try {
    
  class MelisHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.melis-header__drawer');
      this.cartText = this.querySelector('[data-cart-text]');
      this.cartBubble = this.querySelector('#cart-icon-bubble');

      this.querySelectorAll('[data-menu-open]').forEach((button) => {
        button.addEventListener('click', () => this.toggleDrawer(true));
      });

      this.querySelectorAll('[data-menu-close]').forEach((element) => {
        element.addEventListener('click', () => this.toggleDrawer(false));
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.toggleDrawer(false);
      });

      this.querySelectorAll('.melis-header__panel-toggle').forEach((button) => {
        button.addEventListener('click', () => {
          const submenu = button.nextElementSibling;
          const isOpen = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!isOpen));
          if (submenu) submenu.dataset.open = String(!isOpen);
        });
      });

      // Sepet linkinin tamamı çekmeceyi açsın (Dawn sadece #cart-icon-bubble'a bağlanıyor).
      const cartLink = this.querySelector('.melis-header__cart');
      if (cartLink && document.querySelector('cart-drawer')) {
        cartLink.addEventListener('click', (event) => {
          if (event.target.closest('#cart-icon-bubble')) return;
          event.preventDefault();
          this.cartBubble.click();
        });
      }

      this.watchCartCount();
    }

    toggleDrawer(open) {
      if (!this.drawer) return;
      this.drawer.dataset.open = String(open);
      document.body.classList.toggle('overflow-hidden', open);
      const toggle = this.querySelector('[data-menu-open]');
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    }

    // Sepet güncellendiğinde Dawn #cart-icon-bubble içeriğini yeniden basıyor;
    // "Sepet (n)" yazısı onun dışında olduğu için sayıyı buradan takip ediyoruz.
    watchCartCount() {
      if (!this.cartBubble || !this.cartText) return;

      const update = () => {
        const bubble = this.cartBubble.querySelector('.cart-count-bubble span[aria-hidden]');
        const count = bubble ? bubble.textContent.trim() : '0';
        this.cartText.textContent = `Sepet (${count})`;
      };

      new MutationObserver(update).observe(this.cartBubble, { childList: true, subtree: true });
    }
  }

  customElements.define('melis-header', MelisHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class MelisHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-slider__track');
      this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.timer = null;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index), true));
      });

      const prev = this.querySelector('.hero-slider__arrow--prev');
      const next = this.querySelector('.hero-slider__arrow--next');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1, true));

      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncIndex(), 80);
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1, true);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1, true);
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.start();
        }
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    get interval() {
      return Number(this.dataset.autoplay || 0);
    }

    start() {
      this.stop();
      if (!this.interval) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.goTo(this.index + 1, false), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    goTo(index, userInitiated) {
      const count = this.slides.length;
      const target = ((index % count) + count) % count;
      this.index = target;
      this.track.scrollTo({ left: this.slides[target].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActiveDot();
      if (userInitiated) this.start();
    }

    syncIndex() {
      let closest = 0;
      let smallest = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - this.track.scrollLeft);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });
      this.index = closest;
      this.setActiveDot();
    }

    setActiveDot() {
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
    }
  }

  customElements.define('melis-hero-slider', MelisHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-review-wall"] && !Shopify.designMode) return;
  try {
    
  class MelisReviewWall extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.review-wall__lightbox');
      this.lightboxImage = this.querySelector('.review-wall__lightbox img');

      this.querySelectorAll('button.review-wall__card').forEach((card) => {
        card.addEventListener('click', () => {
          if (!this.dialog || !this.lightboxImage) return;
          this.lightboxImage.removeAttribute('width');
          this.lightboxImage.removeAttribute('height');
          this.lightboxImage.src = card.dataset.fullSrc;
          this.lightboxImage.alt = card.dataset.alt || '';
          this.dialog.showModal();
        });
      });

      const close = this.querySelector('.review-wall__lightbox-close');
      if (close) close.addEventListener('click', () => this.dialog.close());

      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }
  }

  customElements.define('melis-review-wall', MelisReviewWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialGallery extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.testimonials__track');
      this.cards = Array.from(this.querySelectorAll('.testimonial-card'));
      this.dots = Array.from(this.querySelectorAll('.testimonials__dot'));
      this.dialog = this.querySelector('.testimonials__lightbox');
      this.lightboxImage = this.querySelector('.testimonials__lightbox img');
      this.closeButton = this.querySelector('.testimonials__lightbox-close');

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const card = this.cards[index];
          if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });

      if (this.track) {
        this.track.addEventListener('scroll', () => this.updateActiveDot());
      }

      this.querySelectorAll('.testimonial-card__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          if (!this.dialog || !this.lightboxImage) return;
          this.lightboxImage.removeAttribute('width');
          this.lightboxImage.removeAttribute('height');
          this.lightboxImage.src = trigger.dataset.fullSrc;
          this.lightboxImage.alt = trigger.dataset.alt || '';
          this.dialog.showModal();
        });
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.dialog.close());
      }

      if (this.dialog) {
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }
    }

    updateActiveDot() {
      if (!this.track || this.cards.length === 0) return;
      let closestIndex = 0;
      let closestDistance = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - this.track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    }
  }

  customElements.define('testimonial-gallery', TestimonialGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melis-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  class MelisVideoProof extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.video-proof__track');
      this.items = Array.from(this.querySelectorAll('.video-proof__item'));
      this.dots = Array.from(this.querySelectorAll('.video-proof__dot'));
      this.loadThumbnails();
      this.loadVideoFiles();
      if (!this.track || this.items.length < 2) return;

      this.index = 0;

      const prev = this.querySelector('.video-proof__arrow--prev');
      const next = this.querySelector('.video-proof__arrow--next');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      });

      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncIndex(), 80);
      });
    }

    // .mp4 videoların adresi bölüm ekrana yaklaşınca verilir (bkz. <video> notu).
    loadVideoFiles() {
      const sources = Array.from(this.querySelectorAll('source[data-src]'));
      if (sources.length === 0) return;

      const load = () => {
        sources.forEach((source) => {
          const video = source.parentElement;
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.preload = 'metadata';
          video.load();
        });
      };

      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          load();
        },
        { rootMargin: '600px 0px' }
      );

      observer.observe(this);
    }

    // Kapak görseli seçilmemişse küçük resmi Vimeo/YouTube'dan çeker.
    loadThumbnails() {
      const placeholders = Array.from(this.querySelectorAll('.video-proof__thumb'));
      if (placeholders.length === 0) return;

      const fill = (element, src) => {
        const image = document.createElement('img');
        image.loading = 'lazy';
        image.alt = '';
        image.src = src;
        element.appendChild(image);
      };

      const load = (element) => {
        const { videoType, videoId, videoHash } = element.dataset;
        if (!videoId || element.dataset.loaded) return;
        element.dataset.loaded = 'true';

        if (videoType === 'youtube') {
          const image = document.createElement('img');
          image.loading = 'lazy';
          image.alt = '';
          image.src = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
          image.addEventListener('error', () => {
            image.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
          });
          element.appendChild(image);
          return;
        }

        // Gizli videolarda oEmbed adresi vimeo.com/ID/HASH biçiminde olmalı.
        const vimeoUrl = videoHash ? `https://vimeo.com/${videoId}/${videoHash}` : `https://vimeo.com/${videoId}`;

        fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(vimeoUrl)}&width=800`)
          .then((response) => (response.ok ? response.json() : null))
          .then((data) => {
            if (data && data.thumbnail_url) fill(element, data.thumbnail_url);
          })
          .catch(() => {
            /* Kapak alınamazsa siyah zemin + oynat tuşu kalır. */
          });
      };

      if (!('IntersectionObserver' in window)) {
        placeholders.forEach(load);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            load(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '200px' }
      );

      placeholders.forEach((element) => observer.observe(element));
    }

    goTo(index) {
      const maxIndex = this.items.length - 1;
      const target = Math.min(Math.max(index, 0), maxIndex);
      this.index = target;
      this.track.scrollTo({ left: this.items[target].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActiveDot();
    }

    syncIndex() {
      let closest = 0;
      let smallest = Infinity;
      this.items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - this.track.offsetLeft - this.track.scrollLeft);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });
      this.index = closest;
      this.setActiveDot();
    }

    setActiveDot() {
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
    }
  }

  customElements.define('melis-video-proof', MelisVideoProof);

  /* ---- Vimeo: sesli baslasin ----
     Tarayicilar sesli otomatik oynatmayi engelledigi icin Vimeo oynatici
     "autoplay=1" gordugunde kendini sessize aliyor ve kullaniciya unmute
     dugmesi birakiyor. Kapak gorseline tiklamak gercek bir kullanici
     hareketi oldugundan sesli oynatma hakkimiz var; oynatici hazir
     sinyalini verdiginde sesi acip yeniden play diyoruz.

     Vimeo JS SDK yuklemeye gerek yok, oynatici postMessage API ile
     konusuyor. Sadece bu bolumdeki iframe lere dokunuluyor. */
  window.addEventListener("message", function (event) {
    if (!/player.vimeo.com/.test(event.origin)) return;

    var data;
    try {
      data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    } catch (e) {
      return;
    }
    if (!data || data.event !== "ready") return;

    var frames = document.querySelectorAll(".video-proof .js-vimeo");
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i];
      if (frame.contentWindow !== event.source) continue;

      var send = function (method, value) {
        var payload = value === undefined ? { method: method } : { method: method, value: value };
        frame.contentWindow.postMessage(JSON.stringify(payload), "*");
      };

      send("setMuted", false);
      send("setVolume", 1);
      send("play");
      break;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-faq"] && !Shopify.designMode) return;
  try {
    
  // SSS açılır/kapanır animasyonu. <details> kapalıyken içeriği render etmediği
  // için CSS geçişi tek başına çalışmıyor; açılışta gerçek yükseklik ölçülüp
  // height canlandırılıyor, geçiş bitince serbest bırakılıyor.
  class MelisFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.accordion__content');
        if (!summary || !content) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        summary.addEventListener('click', (event) => {
          if (reduceMotion) return;
          event.preventDefault();
          if (details.dataset.animating === 'true') return;
          details.dataset.animating = 'true';

          const finish = () => {
            content.style.height = '';
            details.dataset.animating = 'false';
          };

          if (details.open) {
            content.style.height = `${content.scrollHeight}px`;
            requestAnimationFrame(() => {
              content.style.height = '0px';
            });
            content.addEventListener(
              'transitionend',
              () => {
                details.open = false;
                finish();
              },
              { once: true }
            );
          } else {
            details.open = true;
            const target = content.scrollHeight;
            content.style.height = '0px';
            requestAnimationFrame(() => {
              content.style.height = `${target}px`;
            });
            content.addEventListener('transitionend', finish, { once: true });
          }
        });
      });
    }
  }

  customElements.define('melis-faq-accordion', MelisFaqAccordion);

  } catch(e) { console.error(e); }
})();
})();
